module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0148.jpg?v=f2bc0d4a";